import styled from "@emotion/styled";
import theme from "../../theme";
import { keyframes } from "@emotion/react";
import { memo } from "react";

interface Props {
  color?: string;
  width?: string;
  height?: string;
  top?: string;
  right?: string;
}
/**
 * 사용자가 확인하지 않은 새 이벤트 알림
 *
 * 기본값 :
 * color = theme.color.red_500,
 * width = "6.65px",
 * height = "6.65px",
 * top = "8px",
 * right = "8px",
 */
export const NotificationBadge = memo(
  ({
    color = theme.color.red_500,
    width = "6.65px",
    height = "6.65px",
    top = "8px",
    right = "8px",
  }: Props) => {
    return (
      <Badge
        color={color}
        width={width}
        height={height}
        top={top}
        right={right}
      />
    );
  }
);

const ping = keyframes`
75%, 100% {
    transform: scale(2);
    opacity: 0;
}
`;

const Badge = styled.div<{
  color: string;
  width: string;
  height: string;
  top: string;
  right: string;
}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: ${({ color }) => color};
  border-radius: 50%;
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};

  ::before {
    content: "";
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    border-radius: 50%;
    background: ${({ color }) => color};
    position: absolute;
    right: 0;
    animation: ${ping} 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }
`;
